import styled from 'styled-components';

import {
  scale150,
  scale430,
  space3XL,
  spaceL,
  spaceS,
  xdlColorText,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

const ArticleAuthorFollowersContainer = styled.div`
  position: relative;
`;

const ArticleAuthorFollowersHeadline = styled(Headline)`
  position: fixed;
`;

const ArticleAuthorFollowersListContainer = styled.div`
  margin-top: ${scale150};
  max-height: ${scale430};
  overflow: hidden auto;
  padding-top: ${spaceL};
`;

const ArticleAuthorFollowerEntryContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: ${space3XL};
`;

const ArticleAuthorFollowerEntryInfoContainer = styled.div``;

const ArticleAuthorFollowerLink = styled.a`
  color: ${xdlColorText};
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

const ArticleAuthorFollowerTitle = styled(Headline)`
  display: flex;
  align-items: center;

  & > span {
    margin-right: ${spaceS};
  }
`;

export const Styled = {
  ArticleAuthorFollowersContainer,
  ArticleAuthorFollowersHeadline,
  ArticleAuthorFollowersListContainer,
  ArticleAuthorFollowerEntryContainer,
  ArticleAuthorFollowerEntryInfoContainer,
  ArticleAuthorFollowerLink,
  ArticleAuthorFollowerTitle,
};
